import { extractSystemId } from "utils/utils";
import API_URLS from "constants/apis.url";

import { deleteRequest, getRequest, postRequest, putRequest } from "./api";
const isAdminAPI = true;
const TAGS_URL = API_URLS.tagsURL;

export const fetchTagsApi = () => getRequest(TAGS_URL);

export const updateTag = async (tagID, payload) => {
  const systemID = extractSystemId();
  const URL = `${API_URLS.adminSystemsURL}/${systemID}${TAGS_URL}/${tagID}`;
  return await putRequest(URL, payload, true);
};

export const addTag = async payload => {
  const systemId = extractSystemId();
  const URL = `${API_URLS.adminSystemsURL}/${systemId}/add-tag-alarm`;
  return await postRequest(URL, payload, true);
};

export const deleteTagApi = async tagID => {
  const systemID = extractSystemId();
  const URL = `${API_URLS.adminSystemsURL}/${systemID}/delete-tag-alarm/${tagID}`;
  return await deleteRequest(URL, {}, isAdminAPI);
};
